import { render, staticRenderFns } from "./generate-report-button.vue?vue&type=template&id=b10d5510&"
import script from "./generate-report-button.vue?vue&type=script&lang=js&"
export * from "./generate-report-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports